import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Footer from './components/Footer';
import Main from './components/Main';
import ParticlesBackground from './components/Particle';
import './i18n'; 
import "./styles.css";

const App = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang); 
  };

  return (
    <Router>
      <ParticlesBackground />
      <Header onLanguageChange={changeLanguage} />
      <Main /> 
      <Footer />
    </Router>
  );
};

export default App;
